// extracted by mini-css-extract-plugin
module.exports = {"grid":"_zyk0i4Z","gridLinkedImg":"_3wRwHI9","image":"_3zKw90w","gridText":"_IoFXUoq"};